export default __webpack_public_path__ + "static/media/virtual-tour-slide-5-mobile.39be10ce.png";